import LandlordLocationRepository from '../../../repositories/LandlordLocationRepository';
import { LOADING_STATE } from './state';

export default {
    /**
     * Fetches location if not fetched yet.
     * @param {Object} context
     * @returns {Promise<Array>|Array}
     */
    fetchLocations(context) {
        if (context.state.locationsLoading === LOADING_STATE.DURING) {
            return [];
        }

        if (context.state.locationsLoading === LOADING_STATE.AFTER) {
            return context.state.locations;
        }

        context.commit('setLocationsLoading', LOADING_STATE.DURING);
        return LandlordLocationRepository.getLocations({
            exclude: 'landlord,image_url',
        })
            .then(({ data }) => {
                context.commit('setLocations', data);
                context.commit('setLocationsLoading', LOADING_STATE.AFTER);
                return data;
            })
            .catch((response) => {
                // setting it to before, will mean that we will re-try fetching when user switches page
                context.commit('setLocationsLoading', LOADING_STATE.BEFORE);
                return Promise.reject(response);
            });
    },
};
